import { render } from "./HorizontalMenu.vue?vue&type=template&id=5b904f63&scoped=true"
import script from "./HorizontalMenu.vue?vue&type=script&lang=js"
export * from "./HorizontalMenu.vue?vue&type=script&lang=js"

import "./HorizontalMenu.vue?vue&type=style&index=0&id=5b904f63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b904f63"]])

export default __exports__